import * as React from 'react';
import {
  Create,
  SimpleForm,
  FileInput,
  FileField,
  List,
  Datagrid,
} from 'react-admin';

export const StrapiBoxesCreate = (props: any) => {
  const redirect = '/strapi_boxes/create';
  return (
    <Create {...props}>
      <SimpleForm submitOnEnter={false} redirect={redirect}>
        <FileInput
          source="files"
          label="Related files"
          accept=".xlsx,.xls"
          name="files"
        >
          <FileField source="src" title="title" />
        </FileInput>
      </SimpleForm>
    </Create>
  );
};

// Only shows these fields at the moment
export const StrapiBoxesList = (props: any) => {
  return (
    <List {...props}>
      <Datagrid></Datagrid>
    </List>
  );
};
